import React from 'react'
import {useDispatch, useSelector} from "react-redux";
import {removePushNotification} from 'virtual_congress/exhibition_actions'
import RenderedHtmlContent from 'src/shared/virtual_congress/components/rendered_html_content'

export default function PushNotification(props) {
  const dispatch = useDispatch()
  const push_notifications = useSelector((state) => state.push_notifications)

  return <div id="push_notification">
    <div aria-live="polite" aria-atomic="true" style={{position: "relative"}}>
        {push_notifications.map((notification, index) => {
          return <div key={"pushnot" + notification.id} className="toast ml-4 mt-4 mb-2 push-notification" role="alert" aria-live="assertive" aria-atomic="true" style={{position: "absolute", opacity: "1", minWidth: "250px", margin: "auto", zIndex: 1000}}>
            <div className="toast-header">
              <strong className="mr-auto">{notification.title}</strong>
              {/*<small className="text-muted">just now</small>*/}
              <button type="button"
                      className="ml-2 mb-1 close"
                      data-dismiss="toast"
                      aria-label="Close"
                      onClick={() => dispatch(removePushNotification(notification.id))}>
                <span aria-hidden="true"><i className="fa fa-times"></i></span>
              </button>
            </div>
            <div className="toast-body">
              <RenderedHtmlContent html={notification.message}/>
            </div>
          </div>
        })}
    </div>
  </div>
}

